module.exports = __webpack_public_path__ + "static/media/home-background.03ffa396.png";